import React, { Component } from "react";
import { LINKEDIN_SUCCESS_CALLBACK } from "../../../actions/api";
import axios from "axios"; 
import { isAppleSafari } from "../../../utils";
import LoadingScreen from "../../CommonComponents/LoadingScreen";
import Authorization from "../../Authorization/SocialAuth";


export const successLinkedinCallBack = (code) => {
    const codeDataUrl = `${LINKEDIN_SUCCESS_CALLBACK}?code=${code}`
    return axios.get(codeDataUrl);
}

class LinkedInCallBack extends Component {
    componentDidMount() {
    if(!window.location.href.includes("websiteSignupTB")){
        let search = window.location.search;
        let parsed = new URLSearchParams(search);
        const isSafari = isAppleSafari();
        const channel = isSafari ? window : new BroadcastChannel('connect');

        successLinkedinCallBack(parsed.get('code')).then((ResponseData) => {
            const { responseData } = ResponseData.data;

            if (isSafari) {
                window.opener.postMessage(JSON.stringify(responseData), '*');
            } else {
                channel.postMessage(JSON.stringify(responseData));
            }
            setTimeout(() => {
                window.top.close();
            }, 2000)
        }).catch((ex) => {
            console.log("error", ex)
        })
    }
    }
    responseCallback = () => {
        console.log("success")
    }
    render() {
        return window.location.href.includes("websiteSignupTB") ? <Authorization /> : <LoadingScreen />
    }
}

export default LinkedInCallBack;